import { render, staticRenderFns } from "./ShiftType.vue?vue&type=template&id=307fb05c&scoped=true&"
import script from "./ShiftType.vue?vue&type=script&lang=js&"
export * from "./ShiftType.vue?vue&type=script&lang=js&"
import style0 from "./ShiftType.vue?vue&type=style&index=0&id=307fb05c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307fb05c",
  null
  
)

export default component.exports